module.exports = __webpack_public_path__ + "static/media/skeleton_sword.0160ec56.png";